import React from 'react';

import Modal from 'components/shared/Modal/Modal';

import LoginForm from './components/LoginForm';

const LoginModal = ({ isOpen, handleClose, extraLoginParams, onPostLogin }) => {
  return (
    <Modal
      isOpen={isOpen}
      handleClose={handleClose}
      title="Login"
      slideFromRight={false}
      isCentered
      width="small"
      isFooter={false}
      overlayClassName="!z-[200]">
      <LoginForm
        onSuccess={handleClose}
        extraLoginParams={extraLoginParams}
        onPostLogin={onPostLogin}
      />
    </Modal>
  );
};

export default LoginModal;
